import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

function DropdownMenu({ className, children }: Props): JSX.Element {
  return (
    <Menu as="div" className={clsx('relative', className)}>
      {children}
    </Menu>
  );
}

interface DropdownMenuButtonProps {
  className?: string;
  children: React.ReactNode;
}

DropdownMenu.Button = function DropdownMenuButton({
  className,
  children,
}: DropdownMenuButtonProps): JSX.Element {
  return (
    <div>
      <Menu.Button className={className}>{children}</Menu.Button>
    </div>
  );
};

interface DropdownMenuItemsProps {
  className?: string;
  children: React.ReactNode;
}

DropdownMenu.Items = function DropdownMenuItems({
  className,
  children,
}: DropdownMenuItemsProps): JSX.Element {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-out duration-200"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items
        className={clsx(
          'absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
          className,
        )}
      >
        {children}
      </Menu.Items>
    </Transition>
  );
};

interface DropdownMenuItemProps {
  className?: string;
  children: React.ReactNode;
  onClick: () => void;
}

DropdownMenu.ButtonItem = function DropdownMenuItem({
  className,
  children,
  onClick,
}: DropdownMenuItemProps): JSX.Element {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          type="button"
          className={clsx(
            active ? 'bg-gray-100' : '',
            'block w-full px-4 py-2 text-left text-sm text-gray-700',
            className,
          )}
          onClick={onClick}
        >
          {children}
        </button>
      )}
    </Menu.Item>
  );
};

export default DropdownMenu;
